import { IAccount, IPageInfo } from './graph-types';
import { Apollo, gql } from 'apollo-angular-boost';
import { map } from 'rxjs/operators';

// -------------------------------------------------------------------
export enum FetchMoreType {
  First = 0,
  Last = 1,
  AfterCursor = 2,
  BeforeCursor = 3,
}

type onPaginationSuccess = () => void;
type onPaginationFailure = (error: string) => void;

// -------------------------------------------------------------------
// -------------------------------------------------------------------
// -------------------------------------------------------------------
export class PaginationTemplate<T> {
  public items: T[];
  public totalCount: number = 0;
  pageInfo: IPageInfo;
  page: number = 1;
  firstCursor: string = null;
  itemPerPage: number = 5;
  public searchFilter: any;
  currentOffset = 0;
  loading = true;

  query;
  // -------------------------------------------------------------------
  constructor(
    private apollo: Apollo,
    private accountId: string,
    query: any,
    private rootName: string,
    private itemName: string,
    private funnelId: string = null,
    private stage: number = null,
    private startFilter: any = null,
    private onNewData: onPaginationSuccess = null,
    private orgId: string = null,
  ) {
    this.query = query;
    this.searchFilter = startFilter;
    this.subscribeQuery();
  }

  variables: any = null;

  archived: boolean = false;
  logonId: boolean = null;

  // -------------------------------------------------------------------
  isLoading() {
    //console.log('IS LOADING?');
    //console.log(this.loading);
    return this.loading;
  }

  // -------------------------------------------------------------------
  subscribeQuery() {
    this.variables = {
      first: null,
      last: null,
      before: null,
      after: null,
      funnelId: this.funnelId,
      archived: this.archived,
      logonId: this.logonId,
      stage: this.stage,
      skip: 0,
      accountId: this.accountId,
      organizationId: this.orgId,
      searchFilter: JSON.stringify(this.searchFilter),
    };

    this.query.setVariables(this.variables);
    this.query.notifyOnNetworkStatusChange = true;
    this.query.valueChanges.subscribe(value => {
      this.pageInfo = value.data[this.rootName][this.itemName].pageInfo;
      let node = value.data[this.rootName];
      this.items = node[this.itemName].edges.map(e => e.node);

      this.totalCount = node[this.itemName].totalCount;

      console.log('LOADING:');
      console.log(value.loading);
      this.loading = value.loading;

      if (!value.loading) {
        this.callbacks.forEach(cb => {
          if (cb) {
            cb();
          }
        });
        this.callbacks = [];
        //console.log('LOADING OFF');
        this.loading = false;
      }

      if (this.onNewData) {
        this.onNewData();
        //console.log('LOADING NEW DATA');
        //this.loading = false;
      }
    });
  }

  // ----------------------------------------------------------------------------------------------------------------
  // Previous/next page
  // ----------------------------------------------------------------------------------------------------------------
  public nextPage() {
    this.fetchMore(FetchMoreType.AfterCursor);
  }

  // ------------------------------------------------------
  public previousPage() {
    this.fetchMore(FetchMoreType.BeforeCursor);
  }

  // ------------------------------------------------------
  public firstPage() {
    this.fetchMore(FetchMoreType.First);
  }

  // ------------------------------------------------------
  public lastPage() {
    this.fetchMore(FetchMoreType.Last);
  }

  // -------------------------------------------------------------------
  public setStage(stage: number) {
    this.stage = stage;
  }

  // -------------------------------------------------------------------
  public refresh() {
    return this.setOffset(this.variables.skip);
  }

  callbacks = [];

  // ------------------------------------------------------
  public setOffset(offset: number, onsuccess: onPaginationSuccess = null) {
    //console.log('LOADING -> TRUE');
    this.loading = true;
    this.variables.searchFilter = JSON.stringify(this.searchFilter);
    this.variables.skip = offset;
    this.callbacks.push(onsuccess);
    let prom = this.query.refetch(this.variables) as Promise<any>;
    prom.then(() => {
      this.loading = false;
      console.log('HERE offset');
      console.log({ offset });
    });
  }

  // ------------------------------------------------------
  private fetchMore(type: FetchMoreType) {
    // Prepare the query according to the operation
    //console.log('LOADING -> TRUE');
    this.loading = true;
    const variables: any = {
      first: null,
      last: null,
      before: null,
      after: null,
    };
    switch (type) {
      case FetchMoreType.First:
        variables.first = this.itemPerPage;
        break;
      case FetchMoreType.Last:
        variables.last = this.itemPerPage;
        break;
      case FetchMoreType.AfterCursor:
        variables.after = this.pageInfo.endCursor;
        variables.first = this.itemPerPage;
        break;
      case FetchMoreType.BeforeCursor:
        variables.before = this.pageInfo.startCursor;
        variables.last = this.itemPerPage;
        break;
    }

    //console.log(variables);

    // Trigger the query
    this.query.fetchMore({
      variables,
      updateQuery: (previousResult, { fetchMoreResult }) => {
        if (!fetchMoreResult) {
          return previousResult;
        }
        console.log('fetchMore');
        console.log(previousResult);
        console.log(fetchMoreResult);

        this.pageInfo = fetchMoreResult[this.rootName][this.itemName].pageInfo;
        let node = fetchMoreResult[this.rootName];
        this.items = node[this.itemName].edges.map(e => e.node);

        // Just replace the current dataset
        return fetchMoreResult!;
      },
    });
  }
}
